import api from '~api'
import {
  convertPages,
  convertMedia
} from '~utils/api'

export const url = `/job-opening`

export async function getJobOpenings (page) {
  const {
    data
  } = await api.get(`${url}`, {
    params: {
      page
    }
  })

  const jobs = data.data.map((job) => {
    return {
      job_id: job.id,
      job_published_at: job.start_date,
      job_title: job.name,
      job_enterprise_name: job.enterprise_name
    }
  })

  const pages = convertPages(data.meta)

  return ({
    jobs,
    pages
  })
}

export async function getJobById (id) {
  const { data } = await api.get(`${url}/${id}`)

  const response = data.data

  const job = {
    job_id: response.id,
    job_title: response.name,
    job_enterprise_name: response.enterprise_name,
    job_published_at: response.created_at,
    job_content: response.content,
    job_attachments: convertMedia(response.media)
  }
  return (job)
}
